import styled from "styled-components";

export const SmallLoaderAbsolutePosition = styled.div`
  width: 44px;
  height: 44px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;